import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

// FieldWork theme - Dark/neutral tones matching Figma design
const FieldworkPreset = definePreset(Aura, {
  semantic: {
    // Aura 2 slowed modal masks to 0.3s; keep the 0.15s the approved UI shipped with
    mask: {
      transitionDuration: '0.15s',
    },
    primary: {
      50: '#f9fafb',
      100: '#f3f4f6',
      200: '#e5e7eb',
      300: '#d1d5db',
      400: '#9ca3af',
      500: '#6b7280',
      600: '#4b5563',
      700: '#374151',
      800: '#1f2937',
      900: '#111827',
      950: '#030712',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#1f2937',
          contrastColor: '#ffffff',
          hoverColor: '#374151',
          activeColor: '#111827',
        },
        highlight: {
          background: '#1f2937',
          focusBackground: '#374151',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
        surface: {
          0: '#ffffff',
          50: '#f9fafb',
          100: '#f3f4f6',
          200: '#e5e7eb',
          300: '#d1d5db',
          400: '#9ca3af',
          500: '#6b7280',
          600: '#4b5563',
          700: '#374151',
          800: '#1f2937',
          900: '#111827',
          950: '#030712',
        },
      },
      dark: {
        primary: {
          color: '#f3f4f6',
          contrastColor: '#111827',
          hoverColor: '#e5e7eb',
          activeColor: '#d1d5db',
        },
        highlight: {
          background: '#f3f4f6',
          focusBackground: '#e5e7eb',
          color: '#111827',
          focusColor: '#111827',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '100px', // Pill-shaped buttons as in Figma
        paddingX: '1.5rem',
        paddingY: '0.875rem',
      },
    },
    inputtext: {
      root: {
        borderRadius: '8px',
      },
    },
    card: {
      root: {
        borderRadius: '12px',
      },
    },
    dropdown: {
      root: {
        borderRadius: '8px',
      },
    },
  },
});

export default {
  preset: FieldworkPreset,
  options: {
    darkModeSelector: '.app-dark',
    cssLayer: {
      name: 'primeng',
      order: 'tailwind-base, primeng, tailwind-utilities',
    },
  },
};
